export type SeoDto = {
  title: string;
  description: string;
  keywords: string;
  author?: string;

  og: {
    type: PageType;
    title: string;
    description: string;
    image: string;
    image_width: number;
    image_height: number;
    image_type: string;

    article_published_time?: Date;
    article_modified_time?: Date;
  };

  twitter: {
    title: string;
    description: string;
    image: string;
  };
};

export enum PageType {
  ARTICLE = "article",
  WEBSITE = "website",
}
